// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-gray {
    background-color: #f3f4f8;
    border: #0b2d71 2px solid;
    box-shadow: 0 0 10px #0b2d71;
}

.pointer {
    cursor: pointer;
}

.btn-container{
  display: flex !important;
  justify-content: space-between !important;
  margin: 10px 0px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./projects/ert/src/app/administration/picklists/picklists.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,wBAAwB;AAC1B","sourcesContent":[".selected-gray {\n    background-color: #f3f4f8;\n    border: #0b2d71 2px solid;\n    box-shadow: 0 0 10px #0b2d71;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.btn-container{\n  display: flex !important;\n  justify-content: space-between !important;\n  margin: 10px 0px 0px 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
